import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { Image } from "@shared/ui/Image";
import { Type } from "@shared/ui/Type";

export type Props = {
  size?: number;
  image?: string;
  alt?: string;
  className?: string;
  isLoading?: boolean;
};

export const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ size = 64, image, isLoading, alt, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        style={{ width: `${size}px`, height: `${size}px` }}
        className={twMerge(
          "rounded-full overflow-hidden bg-brand-800 flex-shrink-0",
          className
        )}
        {...props}
      >
        {image ? (
          <Image
            src={image}
            alt={alt || "Avatar"}
            className="w-full h-full object-cover"
          />
        ) : (
          <Type
            variant="h5"
            as="div"
            className="w-full h-full flex items-center justify-center text-brand-50"
          >
            {!isLoading && alt ? alt.charAt(0).toUpperCase() : ""}
          </Type>
        )}
      </div>
    );
  }
);

export default Avatar;
